import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(ISignUpRequest) {
    (function(IAnnualSales) {
        IAnnualSales.build = function(partial) {
            return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
        };
    })(ISignUpRequest.IAnnualSales || (ISignUpRequest.IAnnualSales = {}));
    (function(IAnnualInventoryVolume) {
        IAnnualInventoryVolume.build = function(partial) {
            return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
        };
    })(ISignUpRequest.IAnnualInventoryVolume || (ISignUpRequest.IAnnualInventoryVolume = {}));
    (function(EmailPreference) {
        /**
     * We should send emails of a certain type to the user.
     * buf:lint:ignore ENUM_FIRST_VALUE_ZERO
     */ EmailPreference["OPTED_IN"] = "OPTED_IN";
        /**
     * We should not send emails of a certain type to the user.
     */ EmailPreference["OPTED_OUT"] = "OPTED_OUT";
        /**
     * The user has not decided on a preference, we should prompt them at a later time.
     */ EmailPreference["UNDECIDED"] = "UNDECIDED";
    })(ISignUpRequest.EmailPreference || (ISignUpRequest.EmailPreference = {}));
    (function(SmsPreference) {
        SmsPreference["SMS_PREFERENCE_UNKNOWN"] = "SMS_PREFERENCE_UNKNOWN";
        SmsPreference["SMS_PREFERENCE_OPTED_IN"] = "SMS_PREFERENCE_OPTED_IN";
        SmsPreference["SMS_PREFERENCE_OPTED_OUT"] = "SMS_PREFERENCE_OPTED_OUT";
        SmsPreference["SMS_PREFERENCE_UNDECIDED"] = "SMS_PREFERENCE_UNDECIDED";
    })(ISignUpRequest.SmsPreference || (ISignUpRequest.SmsPreference = {}));
    (function(BusinessPlatform) {
        BusinessPlatform["BUSINESS_PLATFORM_UNKNOWN"] = "BUSINESS_PLATFORM_UNKNOWN";
        BusinessPlatform["BRICK_AND_MORTAR"] = "BRICK_AND_MORTAR";
        BusinessPlatform["ONLINE_ONLY"] = "ONLINE_ONLY";
        BusinessPlatform["POP_UP"] = "POP_UP";
        BusinessPlatform["OTHER_PLATFORM"] = "OTHER_PLATFORM";
    })(ISignUpRequest.BusinessPlatform || (ISignUpRequest.BusinessPlatform = {}));
    (function(ShopifyBusinessPlatform) {
        ShopifyBusinessPlatform["SHOPIFY_BUSINESS_PLATFORM_UNKNOWN"] = "SHOPIFY_BUSINESS_PLATFORM_UNKNOWN";
        ShopifyBusinessPlatform["ONLINE_STORE"] = "ONLINE_STORE";
        ShopifyBusinessPlatform["IN_PERSON"] = "IN_PERSON";
        ShopifyBusinessPlatform["SOCIAL_MEDIA"] = "SOCIAL_MEDIA";
        ShopifyBusinessPlatform["OTHER"] = "OTHER";
    })(ISignUpRequest.ShopifyBusinessPlatform || (ISignUpRequest.ShopifyBusinessPlatform = {}));
    (function(NumPhysicalStoresDescriptionOption) {
        NumPhysicalStoresDescriptionOption["NUM_PHYSICAL_STORES_DESCRIPTION_OPTION_UNKNOWN"] = "NUM_PHYSICAL_STORES_DESCRIPTION_OPTION_UNKNOWN";
        NumPhysicalStoresDescriptionOption["ONE"] = "ONE";
        NumPhysicalStoresDescriptionOption["TWO"] = "TWO";
        NumPhysicalStoresDescriptionOption["THREE"] = "THREE";
        NumPhysicalStoresDescriptionOption["FOUR_OR_MORE"] = "FOUR_OR_MORE";
    })(ISignUpRequest.NumPhysicalStoresDescriptionOption || (ISignUpRequest.NumPhysicalStoresDescriptionOption = {}));
    ISignUpRequest.build = function(partial) {
        return _object_spread({
            attributions: [],
            sales_methods: [],
            pre_sign_up_activities: [],
            business_platforms: []
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(ISignUpRequest || (ISignUpRequest = {}));
export var ISignUpRequest;
